import { CheckSquare } from "lucide-react";
import { useTranslate } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";

import { AddTask } from "./AddTask";
import { TasksListContent } from "./TasksListContent";

// LDF: Aufgaben als eigene Seite im Desktop-Menü (am Handy gibt es sie schon unten in der Leiste)
export const TasksPage = () => {
  const translate = useTranslate();
  return (
    <div className="mx-auto mt-4 max-w-[1100px]">
      <Card>
        <CardContent className="space-y-4">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <h1 className="flex items-center gap-2 font-display text-2xl font-semibold">
              <CheckSquare className="h-5 w-5" /> {translate("resources.tasks.name", { smart_count: 2 })}
            </h1>
            <AddTask selectContact />
          </div>
          <TasksListContent />
        </CardContent>
      </Card>
    </div>
  );
};
